module.exports = __webpack_public_path__ + "static/media/electronics.0e401f88.png";